<div class="row" style="max-height:20rem;overflow-y:auto;">
  <div class="col-12 d-flex flex-wrap">
    <div class="iconHolder" *ngFor="let x of availableIcons" (click)="selectIcon(x)" [ngClass]="x == icon ? 'selectedIcon' : ''">
      <i [ngClass]="x"></i>
    </div>
  </div>
</div>
